export default {
    organizationPermission:
        "/gateway/huilianCust/businessPermissioncs/organizationPermission", //企业认证
    personalCertificate:
        "/gateway/huilianCust/businessPermissioncs/personalCertificate", //个人实名认证
    getPersonalFaceCaUrl:
        "/gateway/huilianCust/realCustcs/getPersonalFaceCaUrl", //人脸认证

    checkCertification:
        "/gateway/huilianCust/certificationcs/checkCertification", //校验是否实名
    queryCustomerInfo: "/gateway/huilianCust/logincs/queryCustomerInfo", //客户信息
};



// WEBPACK FOOTER //
// ./src/identityVerification/api.js